module.exports = __webpack_public_path__ + "85a6daf90702e18557786240628270b9.svg";